import logo from '../assets/images/logo.png';
import './Spinner.css';

export default function Spinner({ size = 'large', label = 'Loading...', decorative = false }) {
    return (
        <span
            className={`flow-expert-spinner flow-expert-spinner--${size}`}
            role={decorative ? undefined : 'status'}
            aria-label={decorative ? undefined : label}
            aria-hidden={decorative ? true : undefined}
        >
            <svg className="flow-expert-spinner__ring" viewBox="0 0 100 100" aria-hidden="true">
                <circle className="flow-expert-spinner__track" cx="50" cy="50" r="46" />
                <circle className="flow-expert-spinner__arc" cx="50" cy="50" r="46" pathLength="100" />
            </svg>
            <span className="flow-expert-spinner__badge">
                <img src={logo} alt="" aria-hidden="true" />
            </span>
        </span>
    );
}
